export const BundleProductConfigurationsIdentifier = {
  MINIMUM_NUMBER_OF_ITEMS: 'minimumNumberOfItems',
  MAXIMUM_NUMBER_OF_ITEMS: 'maximumNumberOfItems',
};

export default BundleProductConfigurationsIdentifier;
